import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getAreasDesarrolloPlantelService,
  getAreaDesarrolloPlantelByIdService,
  updateAreaDesarrolloPlantelService,
  toggleAreaDesarrolloPlantelActiveService,
  getAccionesDesarrolloPlantelService,
  getAccionDesarrolloPlantelByIdService,
  updateAccionDesarrolloPlantelService,
  toggleAccionDesarrolloPlantelActiveService,
  createMultiplesAccionesPlantelService,
} from "../../../services/fortalezas/fortalezasPlantel.service";

// ============================================================
// ÁREAS DE DESARROLLO PLANTEL
// ============================================================

export const getAreasDesarrolloPlantelThunk = createAsyncThunk(
  "fortalezasPlantel/getAreas",
  async ({ plantelId, page = 1, search = "" }, { rejectWithValue }) => {
    try {
      return await getAreasDesarrolloPlantelService({ plantelId, page, search });
    } catch (error) {
      if (error.response?.status === 404) return rejectWithValue("Página no válida");
      return rejectWithValue(error.response?.data?.detail || "Error al obtener áreas");
    }
  }
);

export const getAreaDesarrolloPlantelByIdThunk = createAsyncThunk(
  "fortalezasPlantel/getAreaById",
  async (id, { rejectWithValue }) => {
    try {
      return await getAreaDesarrolloPlantelByIdService(id);
    } catch (error) {
      return rejectWithValue(error.response?.data?.detail || "Error al obtener el área");
    }
  }
);

export const updateAreaDesarrolloPlantelThunk = createAsyncThunk(
  "fortalezasPlantel/updateArea",
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      return await updateAreaDesarrolloPlantelService(id, payload);
    } catch (error) {
      return rejectWithValue(error.response?.data?.detail || "Error al actualizar el área");
    }
  }
);

export const toggleAreaDesarrolloPlantelActiveThunk = createAsyncThunk(
  "fortalezasPlantel/toggleAreaActive",
  async (id, { rejectWithValue }) => {
    try {
      return await toggleAreaDesarrolloPlantelActiveService(id);
    } catch (error) {
      return rejectWithValue(error.response?.data?.detail || "Error al cambiar estado del área");
    }
  }
);

// ============================================================
// ACCIONES DE DESARROLLO PLANTEL
// ============================================================

export const getAccionesDesarrolloPlantelThunk = createAsyncThunk(
  "fortalezasPlantel/getAcciones",
  async ({ plantelId, page = 1, search = "", area = "", talento = "" }, { rejectWithValue }) => {
    try {
      return await getAccionesDesarrolloPlantelService({ plantelId, page, search, area, talento });
    } catch (error) {
      if (error.response?.status === 404) return rejectWithValue("Página no válida");
      return rejectWithValue(error.response?.data?.detail || "Error al obtener acciones");
    }
  }
);

export const getAccionDesarrolloPlantelByIdThunk = createAsyncThunk(
  "fortalezasPlantel/getAccionById",
  async (id, { rejectWithValue }) => {
    try {
      return await getAccionDesarrolloPlantelByIdService(id);
    } catch (error) {
      return rejectWithValue(error.response?.data?.detail || "Error al obtener la acción");
    }
  }
);

export const updateAccionDesarrolloPlantelThunk = createAsyncThunk(
  "fortalezasPlantel/updateAccion",
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      return await updateAccionDesarrolloPlantelService(id, payload);
    } catch (error) {
      return rejectWithValue(error.response?.data?.detail || "Error al actualizar la acción");
    }
  }
);

export const toggleAccionDesarrolloPlantelActiveThunk = createAsyncThunk(
  "fortalezasPlantel/toggleAccionActive",
  async (id, { rejectWithValue }) => {
    try {
      return await toggleAccionDesarrolloPlantelActiveService(id);
    } catch (error) {
      return rejectWithValue(error.response?.data?.detail || "Error al cambiar estado de la acción");
    }
  }
);

export const createMultiplesAccionesPlantelThunk = createAsyncThunk(
  "fortalezasPlantel/createMultiplesAcciones",
  async (payload, { rejectWithValue }) => {
    try {
      return await createMultiplesAccionesPlantelService(payload);
    } catch (error) {
      return rejectWithValue(error.response?.data?.detail || "Error al crear las acciones");
    }
  }
);
